/**
 * @file links.js
 * @author Aswin
 * @copyright © 2025 Aswin. All rights reserved.
 * @description Shared external links — single source of truth so URLs don't drift across components
 */

// Résumé — served from a dedicated self-hosted subdomain so the link stays
// stable and the underlying PDF can be updated without a code change.
export const RESUME_URL = 'https://resume.aswincloud.com';
